import defaultLogo from './default-image.svg';
import blackLogo from './skupreme-black.svg';
import catImage from './cat.svg';
import smallWhiteLogo from './small-logo-white.svg';
import { Icons } from './icons';
import logo from './logo.png';

export const Images = {
  default: defaultLogo,
  blackLogo,
  cat: catImage,
  smallWhiteLogo,
  Icons,
  logo,
};
